import {UntilDestroy} from '@ngneat/until-destroy';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent, EventService} from '@spartacus/core';
import {EddlDownloadAttemptEvent} from './events/eddl-download-attempt-event';
import {EddlDownloadSuccessEvent} from './events/eddl-download-success-event';
import {isPlatformBrowser} from '@angular/common';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlDownloadEventService extends DcpDataService<EddlAdobeTrackingData> {

  constructor(protected eventService: EventService,
              @Inject(PLATFORM_ID) public platformId: string,) {
    super();
  }

  fillData(event: CxEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.asset) {
      data.asset = {};
    }
    if (event instanceof EddlDownloadAttemptEvent) {
      data.event = 'downloadAttempt';
      data.asset.url = (event as EddlDownloadAttemptEvent).url;
    } else if (event instanceof EddlDownloadSuccessEvent) {
      data.event = 'downloadSuccess';
      data.asset.url = (event as EddlDownloadSuccessEvent).url;
    }
    if (isPlatformBrowser(this.platformId)) {
      data.asset.page = window.location.href;
    }
    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlDownloadAttemptEvent || event instanceof EddlDownloadSuccessEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }
}
